import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import apiUrls from '../../youwell-common/apiUrls';
import { DefaultProgramImage } from '../../common/image';
import { Image } from '../../youwell-common/components';

const styles = () => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    image: {
        width: '50%',
        marginTop: '10%',
    },
});

class Home extends React.Component {
    render() {
        const {
            classes, currentProgram,
        } = this.props;

        const programImageUrl = currentProgram && currentProgram.frontImageId ? `${apiUrls.baseUrl}/${apiUrls.media.file}/${currentProgram.frontImageId}` : null;

        return (
            <div className={classes.root}>
                {programImageUrl ? (
                    <Image src={programImageUrl} className={classes.image} />
                ) : (
                    <DefaultProgramImage className={classes.image} />
                )}
            </div>
        );
    }
}

Home.propTypes = {
    classes: PropTypes.object.isRequired,
    // translate: PropTypes.func.isRequired,
    currentProgram: PropTypes.object,
};

Home.defaultProps = {
    currentProgram: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    currentProgram: state.publicStore.currentProgramId && state.publicStore.details && state.publicStore.details[state.publicStore.currentProgramId],
});

export default connect(mapStateToProps)(withStyles(styles)(Home));
